import { Azing } from './azing';
import './polyfills';

/**
 * user defined type guard for Azing
 */
function isAzing(arg: any): arg is Azing {
  return arg.user !== undefined;
}

/**
 * window.azing is shared as global object on window so it can be used by other JS apps
 * create new Azing() object if is not already created
 */
export function create(): Azing {
  return Object.assign(new Azing(), (window as any).azing);
}

((window) => {
  (window as any).azing = create();
})(window);
